module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-titel"
  }, [_c('translate', [_vm._v("MFA Verification Instructions")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px 0 20px",
      "padding": "0 20px"
    }
  }, [_c('translate', [_vm._v("If the administrator has opened the team MFA certification, you must bind MFA to log in normally!")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('el-button', {
    staticClass: "mfa-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bindMfa = true
      }
    }
  }, [_c('translate', [_vm._v("Bind Immediately")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "mfa-btn",
    on: {
      "click": _vm.onCancelLogin
    }
  }, [_c('translate', [_vm._v("Unregister")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "copyright clearfix small"
  }, [_c('div', [_vm._v("Copyright 2013-2017 "), _c('translate', [_vm._v("Shanghai Zhuyun Information Technology Co.,Ltd")])], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": _vm.changeInfo ? _vm.attrText.mfaverify : _vm.attrText.bingMfa,
      "visible": _vm.bindMfa
    },
    on: {
      "update:visible": function($event) {
        _vm.bindMfa = $event
      },
      "close": function($event) {
        _vm.onDialogClose()
      }
    }
  }, [(_vm.changeInfo) ? _c('div', {
    staticClass: "dialog-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("1.You must install the MFA application on your smart device to continue")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("2. Common applications that support MFA on smart devices are ")]), _c('a', {
    staticStyle: {
      "color": "#20a0ff"
    },
    attrs: {
      "href": "https://promotion.aliyun.com/ntms/mobile.html",
      "target": "view_window"
    }
  }, [_c('translate', [_vm._v("Identity")])], 1), _c('translate', [_vm._v(", Microsoft Authenticator, Google Authenticator.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("3.If your account has been shared by multiple people, when you successfully bind MFA, other unbound MFA people will not be able to log in. Other people must also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to scan. In consideration of account security, we recommend that you cancel the multiplayer account.")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('translate', [_vm._v("4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.changeInfo) ? _c('div', {
    staticClass: "change-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.onTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.scanCode,
      "name": "scanGet"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.manualInput,
      "name": "handleGet"
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "securityNum",
    attrs: {
      "span": 13
    }
  }, [_c('p', {
    staticClass: "tip-text",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('translate', [_vm._v("Please use the MFA application on your smartphone to scan")])], 1), _vm._v(" "), _c('el-form', {
    ref: "securityNum",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.securityNumForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "label": _vm.attrText.firstCode,
      "prop": "firstCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.securityNumForm.firstCode),
      callback: function($$v) {
        _vm.securityNumForm.firstCode = $$v
      },
      expression: "securityNumForm.firstCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.secondCode,
      "prop": "secondCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.securityNumForm.secondCode),
      callback: function($$v) {
        _vm.securityNumForm.secondCode = $$v
      },
      expression: "securityNumForm.secondCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.activeName === 'scanGet') ? _c('el-col', {
    staticClass: "ewm",
    attrs: {
      "span": 10,
      "offset": 1
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.securityNumForm.mfaEwm,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.activeName === 'handleGet') ? _c('el-col', {
    staticClass: "hand-get handle",
    attrs: {
      "span": 10,
      "offset": 1
    }
  }, [_c('p', [_c('translate', [_vm._v("Authentication information")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("user name")]), _vm._v(": " + _vm._s(_vm.secret.account))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Key")]), _vm._v(": " + _vm._s(_vm.secret.secret))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Please enter the above information manually in the MFA application to obtain the security code")])], 1)]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.changeInfo) ? _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onChangeInfo()
      }
    }
  }, [_c('translate', [_vm._v("Confirm")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.bindMfa = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.changeInfo) ? _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onConfirmOpen()
      }
    }
  }, [_c('translate', [_vm._v("Confirm To Open")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.bindMfa = false;
        _vm.changeInfo = true
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo4.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Powered by\n      "), _c('a', {
    staticClass: "text-primary new-block",
    attrs: {
      "href": "https://cloudcare.cn/",
      "target": "_blank"
    }
  }, [_vm._v("cloudcare.cn")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dbec7a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mfaOpen.vue
// module id = 594
// module chunks = 4 5 6